import { useCallback } from "react";
import moment from "moment";
import { NotificationManager } from "react-notifications";
import { Col, Row } from "react-bootstrap";
import { Field } from "react-final-form";
import { useTranslation } from "react-i18next";
import BMXTextField from "../../../../../Components/Inputs/BMXTextField/BMXTextField";
import BMXSeparator from "../../../../../Components/Separator/BMXSeparator";

import DetailsTable from "../../../../../PC/Components/Tables/DetailsTable/DetailsTable";
import { Badge, Tooltip } from "@mui/material";
import TaskStatus from "./../../ProjectForms/lib/TaskStatus";

import BMXAvatarsUserGroup from "../../../../../Components/BMXAvatarsUserGroup/BMXAvatarsUserGroup";
import { show, hide } from "redux-modal";
import store from "../../../../../store";
import { Icon, IconButton } from "@mui/material";
import { useSelector } from "react-redux";
import { GlobalAuthFetch } from "../../../../../Utils/GlobalAuthFetch/GlobalAuthFetch";
import DoubleLine from "./../../../../../Components/DoubleLine/DoubleLine";
import BMXLinearPogressBar from "../../../../../Components/BMXLinearPogressBar/BMXLinearPogressBar";
const ProjectRealizationTaskModalFormStepOne = ({ workers, ...props }) => {
  const { t } = useTranslation();

  const { dispatch } = store;

  const { projectTasks } = useSelector((state) => state.projectReducer);

  const countProgressValue = (subtasks) => {
    return subtasks?.length
      ? Math.round(
          (subtasks.filter((t) => t.subtaskStatus === "COMPLETED").length /
            subtasks.length) *
            100
        )
      : 0;
  };

  const { uuid, loadData, updateSingleRegistry } = props;

  const circleType = useCallback((taskDeadline, status) => {
    if (!taskDeadline || status === "COMPLETED") return "";
    const diffDays = moment(taskDeadline).diff(moment(), "days", true);
    return { type: diffDays < 0 ? "red" : diffDays <= 3 ? "orange" : "green" };
  }, []);

  function deleteTableElement(element) {
    dispatch(
      show("ConfirmModal", {
        onSubmit: async () => {
          const { payload } = await GlobalAuthFetch({
            path: `/task/${uuid}/subtask/${element.uuid}`,
            method: "DELETE",
          });
          if (payload?.status >= 300 || !payload?.status) {
            return;
          }
          loadData();
          NotificationManager.success(t("global:success"));
          dispatch(hide("ConfirmModal"));
        },
      })
    );
  }
  function openChat(element) {
    dispatch(show("ProjectChatModal", { element, loadData, taskUuid: uuid }));
  }

  const changeSubtaskStatus = async (subtask, newStatus) => {
    const response = await GlobalAuthFetch({
      path: `/task/${uuid}/subtask/${subtask.uuid}/status`,
      method: "PATCH",
      data: { newStatus },
      headers: {
        "Content-Type": "application/json",
      },
    });

    if (response?.payload?.status === 200) {
      NotificationManager.success(t("global:project.taskStatusChanged"));
      loadData();
    } else {
      NotificationManager.error(t("global:project.taskStatusChangeError"));
    }
  };

  return (
    <div className="AddProjectStepOne" style={{ justifyContent: "flex-start" }}>
      <BMXSeparator title={t("global:project.basicInformation")} />
      <Row>
        <Col xs={12}>
          <Field
            component={BMXTextField}
            label={`${t("global:project.taskDescription")}`}
            name="taskDescription"
            multiline
            maxRows={3}
            data-cy="taskDescription"
            readOnly
          />
        </Col>
      </Row>
      <Row>
        <Col className="mt-4" xs={{ span: 8, offset: 2 }}>
          <BMXLinearPogressBar
            value={countProgressValue(
              projectTasks?.find((e) => e?.uuid === uuid)?.subtasks
            )}
          />
        </Col>
      </Row>
      <Row>
        <Col xs={{ span: 12 }} className="mt-3">
          <BMXSeparator title={t("global:project.subtasks")} />
        </Col>
      </Row>
      <Row>
        <Col xs={12} className="mt-3">
          <DetailsTable
            buttons={
              <>
                {" "}
                <Tooltip title={t("global:project.addSubtask")}>
                  <IconButton
                    sx={{
                      borderRadius: "1px",
                      padding: "1px",
                      backgroundColor: "var(--BMX-primary)",
                      "&:hover": {
                        backgroundColor: "var(--BMX-primary)",
                        boxShadow: "none",
                      },
                      marginBottom: "0.8rem",
                      marginRight: "0.5rem",
                    }}
                    onClick={() => {
                      dispatch(
                        show("AddSubtaskProjectModal", {
                          uuid,
                          loadData,
                          header: t("global:project.addSubtask"),
                          updateTask: false,
                          updateSingleRegistry: updateSingleRegistry,
                        })
                      );
                    }}
                  >
                    <Icon
                      className="white text"
                      style={{ fontSize: "0.95rem" }}
                    >
                      add
                    </Icon>
                  </IconButton>
                </Tooltip>
              </>
            }
            headers={[
              {
                key: "subtaskNumber",
                name: t("global:project.subtaskNumber"),
                width: "9%",
                sort: true,
              },
              {
                key: "subtaskContent",
                name: t("global:project.subtaskContent"),
                width: "21%",
                tooltip: true,
                sort: true,
              },
              {
                key: "subtaskAssignee.worker",
                name: t("global:project.subtaskAssignee"),
                width: "15%",
                sort: false,
              },
              {
                key: "subtaskStartDate",
                name: t("global:project.subtaskStartDate"),
                width: "12%",
                sort: true,
                momentDate: true,
                momentTime: true,
              },
              {
                key: "subtaskEndDate",
                name: t("global:project.subtaskEndDate"),
                width: "12%",
                sort: true,
                momentDate: true,
                momentTime: true,
              },
              {
                key: "subtaskDeadline",
                name: t("global:project.subtaskDeadline"),
                width: "10%",
                sort: true,
              },
              {
                key: "subtaskStatus",
                name: t("global:project.subtaskStatus"),
                width: "12%",
                sort: true,
              },
              {
                key: "actions",
                name: "",
                width: "10%",
                sort: false,
              },
            ]}
            taskUuid={uuid}
            data={projectTasks
              ?.find((e) => e.uuid === uuid)
              ?.subtasks?.map((el) => ({
                ...el,
                subtaskStatus: (
                  <>
                    <TaskStatus
                      value={el?.subtaskStatus}
                      onChange={(newStatus) =>
                        changeSubtaskStatus(el, newStatus)
                      }
                    />
                  </>
                ),
                "subtaskAssignee.worker": (
                  <BMXAvatarsUserGroup workers={el?.subtaskAssignee} />
                ),
                subtaskDeadline: (
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <div
                      style={{ marginRight: "5px" }}
                      className={`circle ${
                        circleType(el?.subtaskDeadline, el?.subtaskStatus).type
                      }`}
                    />

                    <DoubleLine
                      firstLine={moment(el?.subtaskDeadline).format(
                        "DD-MM-YYYY"
                      )}
                      secondLine={moment(el?.subtaskDeadline).format("HH:mm")}
                    />
                  </div>
                ),

                actions: (
                  <div style={{ display: "flex" }}>
                    <IconButton onClick={() => openChat(el)}>
                      <Badge
                        badgeContent={el?.comments?.length}
                        sx={{
                          "& .MuiBadge-badge": {
                            minWidth: "15px",
                            bgcolor: "var(--BMX-secondary)",
                            height: "15px",
                            borderRadius: "50%",
                            fontSize: "0.53rem",
                            padding: "0px",

                            transform: "translate(11px, -8px)",
                            color: "#fff",
                          },
                        }}
                      >
                        <Icon
                          sx={{ color: "var(--BMX-primary)" }}
                          className="text"
                          style={{ fontSize: "1rem" }}
                        >
                          chat_bubble
                        </Icon>
                      </Badge>
                    </IconButton>

                    <IconButton onClick={() => deleteTableElement(el)}>
                      <Icon
                        className="text error"
                        style={{ fontSize: "1.2rem" }}
                      >
                        delete
                      </Icon>
                    </IconButton>
                    <IconButton
                      onClick={() => {
                        dispatch(
                          show("AddSubtaskProjectModal", {
                            uuid,
                            loadData,
                            initialValues: el,
                            header: t("global:project.addSubtask"),
                            update: true,
                            updateSingleRegistry: updateSingleRegistry,
                          })
                        );
                      }}
                      size="small"
                    >
                      <Icon
                        className="primary text"
                        style={{ fontSize: "0.95rem" }}
                      >
                        edit
                      </Icon>
                    </IconButton>
                  </div>
                ),
              }))}
          />
        </Col>
      </Row>
    </div>
  );
};

export default ProjectRealizationTaskModalFormStepOne;
